import classNames from 'classnames';
import type { CSSProperties } from 'react';

import List from '@/icon/List';
import X from '@/icon/X';
import { NAVBAR_MENU_BURGER_DEFAULTS } from '@/navbarElement/NavbarMenuBurger';
import * as styles from '../navbarElement/Navbar.css';
import type { NavbarMenuBurgerElementProps } from '../navbarElement/Navbar.type';
import { computeColor } from '../utils/colors';
import * as v2Styles from './NavbarMenuBurger.css';

export function NavbarMenuBurgerV2(props: NavbarMenuBurgerElementProps) {
  const { element, className, attributes } = props;
  const { color, size, customAttributes } = element.attrs || {};

  return (
    // biome-ignore lint/a11y/useValidAriaRole: none
    // biome-ignore lint/a11y/noInteractiveElementToNoninteractiveRole: TODO not sure why?
    <button
      // onClick={() => setIsOpen((o) => !o)}
      {...props}
      role="none"
      {...customAttributes}
      {...attributes}
      className={classNames(styles.navbarMenuBurger, className, customAttributes?.className)}
      style={
        {
          '--text-color': computeColor(color ?? NAVBAR_MENU_BURGER_DEFAULTS.color),
        } as CSSProperties
      }
    >
      <List size={size || NAVBAR_MENU_BURGER_DEFAULTS.size} weight="bold" className={v2Styles.openIcon} />
      <X size={size || NAVBAR_MENU_BURGER_DEFAULTS.size} weight="bold" className={v2Styles.closeIcon} />
    </button>
  );
}
